/** Iglu delete sentinel — must match server `IGLU_DELETE_SENTINEL` */
const SENTINEL = 'ig.field.type.delete';

/** `historySlugs` wire shape: string[], occasional legacy string, or unset/sentinel */
export function historySlugsFromIglu(v: unknown): string[] {
  if (v == null || v === SENTINEL) return [];
  if (Array.isArray(v))
    return v.map((x) => String(x).trim()).filter((s) => s.length > 0 && s !== SENTINEL);
  if (typeof v === 'string') {
    const t = v.trim();
    if (!t || t === SENTINEL) return [];
    return [t];
  }
  return [];
}
